// extracted by mini-css-extract-plugin
export default {"privacy":"PipeGarden_privacy__1kuuY","listLink":"PipeGarden_listLink__7Ti9L"};